import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'
import { CookieNotice } from '@/components/generals/cookie-notice'

/**
 * The whole site sits inside a 1600px frame with a 60px ruled gutter on each
 * side. The gutters slide in horizontally on load, the navbar drops from above.
 */
export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            <Navbar />

            <div className='relative mx-auto w-full max-w-[1600px] flex-1'>
                <div
                    aria-hidden='true'
                    data-load='left'
                    data-load-delay='0.2'
                    className='pointer-events-none absolute inset-y-0 left-0 z-[7] hidden w-[60px] border-r border-line tab:block'
                />

                <div
                    aria-hidden='true'
                    data-load='right'
                    data-load-delay='0.2'
                    className='pointer-events-none absolute inset-y-0 right-0 z-[7] hidden w-[60px] border-l border-line tab:block'
                />

                <main className='relative z-[2] pt-[64px] tab:pt-[80px]'>
                    {children}
                </main>

                <Footer />
            </div>

            <CookieNotice />
        </div>
    )
}
